import { InstallationPriceSimulationService } from '@modules/installation-price-simulation/infrastructure/installation-price-simulation.service'
import { InstallationPriceSimulationRequest } from '@modules/installation-price-simulation/infrastructure/installation-price-simulation-request.types'
import { InstallationPriceSimulation } from '@modules/installation-price-simulation/domain'

type Callbacks = {
  onInstallationPriceSimulation: (
    simulation: InstallationPriceSimulation
  ) => void
  onError: (error: string) => void
}

type ApiErrors = {
  400: string
  401: string
  404: string
  500: string
  503: string
}

export function handlerSimulateInstallationPrice() {
  return { execute }

  async function execute(
    params: InstallationPriceSimulationRequest,
    { onInstallationPriceSimulation, onError }: Callbacks
  ) {
    try {
      const simulation = await InstallationPriceSimulationService.simulate(
        params
      )
      onInstallationPriceSimulation(simulation)
    } catch (error) {
      const errors: ApiErrors = {
        400: 'installation-price-simulation-param-request-wrong',
        401: 'unauthorized',
        404: 'installation-price-simulation-not-found',
        500: 'api-error',
        503: 'api-error',
      }

      const status = error.response?.status
      const mapped = status ? errors[status as keyof ApiErrors] : undefined
      onError(mapped || 'api-error')
    }
  }
}
